module.exports = __webpack_public_path__ + "img/3ds.f9ee5baa.svg";